export default {
  'menu.dashboard.workplace': '工作台（旧）',
  'workplace.welcome': '欢迎回来！',
  'workplace.balance': '余额（元）',
  'workplace.order.pending': '待支付',
  'workplace.order.pendingRenewal': '待续费订单',
  'workplace.onlineContent': '线上总内容',
  'workplace.putIn': '投放中内容',
  'workplace.newDay': '日新增评论',
  'workplace.newFromYesterday': '较昨日新增',
  'workplace.stats.totalVisits': '总访问量',
  'workplace.stats.uniqueVisitors': '独立访客',
  'workplace.stats.pageViews': '浏览量',
  'workplace.stats.avgDuration': '平均停留',
  'workplace.stats.ordersCount': '订单数',
  'workplace.stats.ordersGmv': '订单 GMV',
  'workplace.stats.paidRevenue': 'Paid Revenue（已支付总额）',
  'workplace.stats.newSubscriptions': '新增订阅',
  'workplace.stats.activeSubscriptions': '活跃订阅',
  'workplace.ordersTrend': '订单趋势',
  'workplace.chart.ordersCount': '订单数',
  'workplace.chart.ordersTrendHigh': '最高',
  'workplace.chart.ordersTrendLow': '最低',
  'workplace.subscriptionsTrend': '订阅趋势',
  'workplace.chart.subscriptionsNew': '新增订阅',
  'workplace.chart.subscriptionsCancelled': '取消订阅',
  'workplace.topShopsByGmv': '店铺 GMV 排行',
  'workplace.topShopsByRevenue': '店铺营业额排行',
  'workplace.topRegionsByOrders': '购买地区订单排行',
  'workplace.top.rank': 'No.',
  'workplace.top.shopId': '店铺',
  'workplace.top.region': '地区',
  'workplace.top.gmv': 'GMV',
  'workplace.top.revenue': '营业额',
  'workplace.top.orders': '订单数',
  'workplace.subscriptionStatusPie': '订阅状态分布',
  'workplace.subscriptionTotal': '订阅条数',
  'workplace.subscriptionCohort': '订阅 cohort（按创建月）',
  'workplace.cohort.month': '创建月',
  'workplace.cohort.new': '新增',
  'workplace.cohort.active': '仍活跃',
  'workplace.cohort.cancelled': '已取消(截至期末)',
  'workplace.cohort.activeRate': '活跃占比',
  'workplace.dashboardScopeHint': '未配置看板范围：请使用带商户的账号登录，或配置 VITE_DASHBOARD_SHOP_IDS。',
  'workplace.minute': '分钟',
  'workplace.docs': '帮助文档',
  'workplace.docs.productOverview': '产品概要',
  'workplace.docs.userGuide': '使用指南',
  'workplace.docs.workflow': '接入流程',
  'workplace.docs.interfaceDocs': '接口文档',
  'workplace.contentManagement': '内容管理',
  'workplace.contentStatistical': '内容分析',
  'workplace.advanced': '高级管理',
  'workplace.onlinePromotion': '线上推广',
  'workplace.contentPutIn': '内容投放',
  'workplace.announcement': '公告',
  'workplace.recently.visited': '最近访问',
  'workplace.record.nodata': '暂无数据',
  'workplace.quick.operation': '快捷操作',
  'workplace.quickOperation.setup': '管理',
  'workplace.allProject': '所有项目',
  'workplace.loadMore': '加载更多',
  'workplace.viewMore': '查看更多',
  'workplace.contentData': '内容数据',
  'workplace.popularContent': '线上热门内容',
  'workplace.popularContent.text': '文本',
  'workplace.popularContent.image': '图片',
  'workplace.popularContent.video': '视频',
  'workplace.categoriesPercent': '内容类型占比',
  'workplace.pecs': '个',
  'workplace.realtimeVisitors': '位实时访客',

  // Orders dashboard / Subscriptions dashboard (new pages)
  'orders.stats.ordersCount': '订单数',
  'orders.stats.gmv': 'GMV',
  'orders.stats.paidRevenue': '营业额',
  'orders.stats.paidRevenueCnyWan': '约合 ¥{n} 万',
  'orders.stats.paidRevenueCnyYi': '约合 ¥{n} 亿',
  'orders.stats.paidRevenueCnyYuan': '约合 ¥{n}',
  'orders.stats.paidOrdersCount': '成交订单数',
  'orders.stats.paidRate': '成单率',
  'orders.realtime.newOrderTitle': '新订单成交',
  'orders.realtime.newOrderContent': '店铺 {shop} · {method} · ${amount}',
  'orders.paymentMethodSuccess': '支付通道分布与成功率',
  'orders.payment.method': '支付通道',
  'orders.payment.methodShare': '支付通道占比',
  'orders.payment.orderShare': '支付次数占比',
  'orders.payment.shareListEmpty': '当前范围内暂无支付通道数据',
  'orders.payment.orders': '支付次数',
  'orders.payment.paid': '已支付',
  'orders.payment.successRate': '成功率',
  'orders.payment.mode.real': '去重',
  'orders.payment.mode.all': '全量',
  'orders.payment.successRateBlockSub': '按支付次数与成功率（支付流水）',
  'orders.payment.successDetailLine': '支付 {attempts} · 成功 {paid}',
  'orders.payment.successRateListEmpty': '当前范围内暂无成功率数据',
  'orders.payment.paidAmountByMethod': '各支付方式收款金额',
  'orders.payment.paidAmountBlockSub': '按已支付金额统计（USD，与上方统计口径一致）',
  'orders.payment.paidAmountDetailLine': '成功 {paid} 笔 · 占比 {share}%',
  'orders.payment.paidAmountListEmpty': '当前范围内暂无收款金额数据',
  'orders.payment.paidAmountTotal': '合计',
  'orders.payment.paidRevenue': 'Paid Revenue',
  'orders.filters.title': '筛选条件',
  'orders.filters.all': '全部',
  'orders.filters.merchant': '选择商户',
  'orders.filters.shop': '选择店铺',
  'orders.filters.range': '时间区间',
  'orders.filters.quickRange': '快捷时间',
  'orders.filters.timezone': '选择时区',
  'orders.filters.timezoneLocal': '本地时区',
  'orders.filters.reset': '重置',
  'orders.filters.mobileHint': '轻点展开筛选',
  'orders.filters.today': '今天',
  'orders.filters.yesterday': '昨天',
  'orders.filters.thisWeek': '本周',
  'orders.filters.last7d': '近 7 天',
  'orders.filters.last14d': '近 14 天',
  'orders.filters.last30d': '近 30 天',
  'orders.filters.thisMonth': '本月',
  'orders.filters.thisQuarter': '本季度',
  'orders.filters.thisYear': '今年',
  'orders.hourly.title': '24 小时时间段订单量',
  'orders.hourly.ordersCount': '订单量',
  'orders.ratio.title': '订阅占成交订单占比',
  'orders.ratio.newSubscriptions': '新增订阅',
  'orders.ratio.deals': '成交订单',
  'orders.ratio.otherDeals': '非订阅成交',
  'orders.ratio.subscriptionsRate': '订阅占比',
  'subscriptions.stats.newSubscriptions': '新增订阅',
  'subscriptions.stats.activeSubscriptions': '活跃订阅',
  'subscriptions.stats.cancelledSubscriptions': '取消订阅',
  'subscriptions.upcomingRenewals.title': '下次续费时间',
  'subscriptions.upcomingRenewals.hint': '今天起（不受时间区间影响）',
  'subscriptions.upcomingRenewals.count': '{n} 条记录',
  'subscriptions.upcomingRenewals.maxHint': '最多显示 {n} 条',
  'subscriptions.renewalStats.title': '续费统计',
  'subscriptions.renewalStats.hint': '按时间范围',
  'subscriptions.renewalStats.txnSection': '续费成交',
  'subscriptions.renewalStats.txnSectionDesc':
    '按续费订单成交时间统计（真实扣款，已支付即成功）',
  'subscriptions.renewalStats.txnOrders': '续费订单',
  'subscriptions.renewalStats.txnPaid': '成功(已支付)',
  'subscriptions.renewalStats.txnUnpaid': '失败(未支付)',
  'subscriptions.renewalStats.txnPaidAmount': '已支付金额',
  'subscriptions.renewalStats.txnSuccessCountSub': '成功 {n} / 续费订单',
  'subscriptions.renewalStats.lifecycleSection': '到期订阅状态',
  'subscriptions.renewalStats.lifecycleSectionDesc':
    '按下次扣款日落在区间，统计订阅当前状态',
  'subscriptions.renewalStats.subscriptionCount': '订阅数',
  'subscriptions.renewalStats.renewalCount': '续费数',
  'subscriptions.renewalStats.successRate': '成功率',
  'subscriptions.renewalStats.cancelledCount': '取消',
  'subscriptions.renewalStats.failedCount': '失败',
  'subscriptions.renewalStats.pendingRetryCount': '待重试(失败)',
  'subscriptions.renewalStats.pausedCount': '暂停',
  'subscriptions.renewalStats.deletedCount': '删除',
  'subscriptions.renewalStats.subscriptionCountSub': '区间累计',
  'subscriptions.renewalStats.renewalBillableSub': '不含取消/暂停/删除',
  'subscriptions.renewalStats.successCountSub': '成功 {n} 笔 / 续费数',
  'subscriptions.renewalStats.pendingRetrySub': '有网关续费激活',
  'subscriptions.renewalStats.pendingBillingCount': '待扣费数',
  'subscriptions.renewalStats.failureCount': '失败数',
  'subscriptions.renewalStats.pendingBillingSub': '无网关续费激活',
  'subscriptions.renewalStats.noGateway.title': '无网关',
  'subscriptions.renewalStats.rateSub': '占比 {n}%',
  'subscriptions.renewalStats.byPaymentMethod': '按支付渠道',
  'subscriptions.renewalStats.col.gateway': '支付网关',
  'subscriptions.renewalStats.col.paymentMethod': '支付方式',
  'subscriptions.renewalStats.col.success': '成功',
  'subscriptions.renewalStats.col.cancelled': '取消',
  'subscriptions.renewalStats.col.cancelledRate': '取消率',
  'subscriptions.renewalStats.col.failed': '失败',
  'subscriptions.renewalStats.col.pendingRetry': '待重试(失败)',
  'subscriptions.renewalStats.col.paused': '暂停',
  'subscriptions.renewalStats.col.pausedRate': '暂停率',
  'subscriptions.renewalStats.col.deleted': '删除',
  'subscriptions.renewalStats.col.deletedRate': '删除率',
  'subscriptions.renewalStats.gateway.paypal': 'PayPal',
  'subscriptions.renewalStats.gateway.ppcp': 'PayPal PPCP',
  'subscriptions.renewalStats.gateway.stripe': 'Stripe',
  'subscriptions.renewalStats.gateway.manual': '手动',
  'subscriptions.renewalStats.paymentMethod.card': '银行卡',
  'subscriptions.renewalStats.paymentMethod.paypal': 'PayPal',
  'subscriptions.renewalStats.paymentMethod.ppcp': 'PayPal PPCP',
  'subscriptions.renewalStats.paymentMethod.apple_pay': 'Apple Pay',
  'subscriptions.renewalStats.paymentMethod.google_pay': 'Google Pay',
};
